import { makeEnvironmentProviders } from '@angular/core';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializer } from './lowercase-url-serializer';

export function provideLowerCaseUrlSerializer() {
  return makeEnvironmentProviders([{ provide: UrlSerializer, useClass: LowerCaseUrlSerializer }]);
}
